import React, { FC, ReactChild } from 'react';
import { isClient } from '~/src/constants/env';
import useCreateFeedback from '~/src/hooks/useCreateFeedback';
import { OnboardingAppTypes, useOnboardingServices } from '../CustomApp/OnboardingCustomApp';
import DesktopNavigationBar from './components/DesktopNavigationBar';
import { DesktopNavigationBarProps } from './components/DesktopNavigationBar/DesktopNavigationBar';
import MobileHeader, { MobileHeaderProps } from './components/MobileHeader/MobileHeader';
import {
  desktopContainerStyles,
  desktopMainContainerStyles,
  rightContainerStyles,
  mobileContainerStyles,
  mobileMainContainerStyles,
  RIGHT_CONTAINER_WIDTH,
} from './styles.css';
import { NAV_BAR_WIDTH } from './components/DesktopNavigationBar/styles.css';
import AdBanner from './components/AdBanner';
import DeeplinkModal from '../DeeplinkModal';

type OnboardingPageLayoutProps = OnboardingAppTypes & {
  isDesktop: boolean;
  rightContainerContent?: ReactChild;
  canShowDeeplink?: boolean;
} & DesktopNavigationBarProps &
  MobileHeaderProps;

const OnboardingPageLayout: FC<OnboardingPageLayoutProps> = ({
  children,
  rightContainerContent,
  onItemClick,
  leftSlot,
  isDesktop,
  canShowDeeplink = true,
}) => {
  useCreateFeedback();

  const { Analytics, Adsense, isDeeplinkModalOpen, onDeeplinkClose } = useOnboardingServices();

  const renderChildren = (type: 'desktop' | 'mobile') => {
    if (isClient) {
      const showChildren = isDesktop ? type === 'desktop' : type === 'mobile';
      return showChildren && children;
    }
    return children;
  };

  return (
    <>
      <div className={desktopContainerStyles}>
        <DesktopNavigationBar
          onItemClick={onItemClick}
          banner={
            isClient && isDesktop ? <AdBanner slot="bannerLeft" format="rectangle" placement="banner_left" /> : null
          }
        />

        <div className={desktopMainContainerStyles}>{renderChildren('desktop')}</div>

        <div className={rightContainerStyles}>
          {rightContainerContent}
          {isClient && isDesktop && <AdBanner slot="bannerRight" placement="banner_right" />}
        </div>

        {isClient &&
          isDesktop &&
          Adsense.renderBanner({
            slot: 'bannerBottom',
            format: 'horizontal',
            placement: 'bottom_banner',
            style: {
              maxWidth: `calc(100% - ${NAV_BAR_WIDTH} - ${RIGHT_CONTAINER_WIDTH})`,
              height: 'auto',
              position: 'fixed',
              bottom: 0,
              left: NAV_BAR_WIDTH,
              right: RIGHT_CONTAINER_WIDTH,
              display: 'flex',
              justifyContent: 'center',
              margin: 'auto',
              transition: 'all .3s ease-in-out',
            },
          })}
      </div>
      <div className={mobileContainerStyles}>
        <MobileHeader leftSlot={leftSlot} />

        <div className={mobileMainContainerStyles}>{renderChildren('mobile')}</div>

        {isClient &&
          !isDesktop &&
          Adsense.renderBanner({
            slot: 'bannerBottom',
            format: 'fluid',
            placement: 'bottom_banner',
            style: {
              maxWidth: '100%',
              height: '50px',
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              margin: 'auto',
            },
          })}
      </div>

      {isDeeplinkModalOpen && canShowDeeplink && (
        <DeeplinkModal onRequestClose={onDeeplinkClose} Analytics={Analytics} />
      )}
    </>
  );
};

export default OnboardingPageLayout;
